import { j as r } from "../../../jsx-runtime-B6kdoens.js";
import { a as t } from "../../../index-CROKJrb5.js";
import { c as i, f as m } from "../../../create-component-CBAeEoQ6.js";
import { Link as u } from "../../Link/index.js";
import { CurologyLogoStickerIcon as n } from "../../Icon/icons/CurologyLogoStickerIcon/index.js";
import { AgencyLogoStickerIcon as a } from "../../Icon/icons/AgencyLogoStickerIcon/index.js";
import { useBrand as x } from "../../../brand/context/index.js";
const h = i(
  "FooterLogo",
  m(({ className: o, ...e }, c) => {
    const s = x();
    return /* @__PURE__ */ r.jsx(
      "div",
      {
        className: t(
          "cur-order-3 cur-flex cur-w-1/2 cur-shrink cur-grow cur-basis-0 cur-self-start md:cur-order-2 md:cur-justify-end lg:cur-order-3 lg:cur-w-0",
          o
        ),
        children: /* @__PURE__ */ r.jsx(u, { ref: c, ...e, children: s === "curology" ? /* @__PURE__ */ r.jsx(n, { size: "xxl" }) : /* @__PURE__ */ r.jsx(a, { className: "cur-text-inverse", size: "xxl" }) })
      }
    );
  })
);
export {
  h as FooterLogo
};
//# sourceMappingURL=index.js.map
